export default "__VITE_ASSET__220fe386__"